var _ArrowRight;
import ArrowRight from '@crehana/icons/outline/ArrowRight';
import cn from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ArrowButton = function ArrowButton(_ref) {
  var onClick = _ref.onClick,
    label = _ref.label,
    className = _ref.className;
  return /*#__PURE__*/_jsxs("button", {
    className: cn('tw-btn-primary-xs', className),
    type: "button",
    onClick: onClick,
    children: [_ArrowRight || (_ArrowRight = /*#__PURE__*/_jsx(ArrowRight, {
      ignoreColor: true,
      className: "tw-fill-current",
      size: 16
    })), label]
  });
};
export default ArrowButton;